import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";



@Component({
  selector: 'GeschlechtsAuswahl',
  templateUrl: './GeschlechtsAuswahl.html',
  styleUrl: './GeschlechtsAuswahl.css',
  imports: [
    CommonModule,
    FormsModule
  ],
})
export class GeschlechtsAuswahl {

  Data = [
    { key: 1, Bezeichnung: "Mänl." },
    { key: 2, Bezeichnung: "Weibl." },
    { key: 3, Bezeichnung: "Divers" },
  ]

  @Input() Geschlecht: number = 0;
  @Output() GeschlechtChange = new EventEmitter<number>();

  onStatusChange(value: any) {
    console.log(value);
    // Emit the value to the parent
    this.GeschlechtChange.emit(Number(value));
  }
}
